import { Injectable } from "@angular/core";
import { HttpService } from "app/js/src/infrastructure/http/http";
import {
  IDestinationTypeDefaultsProvider,
} from "app/js/src/domain/clipping-studio/publish/i-destination-type-defaults-provider";
import type {
  DestinationConfig,
  DestinationType,
} from "app/js/src/domain/clipping-studio/publish/publish-models";
import { AspectRatio, parseAspectRatio } from "app/js/src/domain/clipping-studio/aspect-ratio";

/** API response item (camelCase or PascalCase from backend). */
interface DestinationTypeDefaultApiItem {
  destinationType?: string;
  DestinationType?: string;
  aspectRatio?: string;
  AspectRatio?: string;
}

const DESTINATION_TYPES: DestinationType[] = ["yt", "fb", "ttv", "ig", "s3", "tt"];

function mapApiItemToConfig(item: DestinationTypeDefaultApiItem): DestinationConfig {
  return {
    aspectRatio: parseAspectRatio(item.aspectRatio ?? item.AspectRatio ?? AspectRatio.Aspect16x9),
  };
}

@Injectable()
export class ClippingStudioDestinationTypeDefaultsHttpProviderService extends IDestinationTypeDefaultsProvider {
  private readonly url = "clipping-studio/destination-type-defaults";

  constructor(private readonly httpService: HttpService) {
    super();
  }

  async getDefaultConfigs(): Promise<Record<DestinationType, DestinationConfig>> {
    try {
      const raw = await this.httpService.get(this.url);
      const arr = Array.isArray(raw) ? raw : [];
      const items = arr as DestinationTypeDefaultApiItem[];
      const result: Record<DestinationType, DestinationConfig> = {} as Record<DestinationType, DestinationConfig>;
      for (const item of items) {
        const type = (item.destinationType ?? item.DestinationType ?? "").toLowerCase();
        if (DESTINATION_TYPES.includes(type as DestinationType)) {
          result[type as DestinationType] = mapApiItemToConfig(item);
        }
      }
      return result;
    } catch {
      return {} as Record<DestinationType, DestinationConfig>;
    }
  }
}
